<script>
import { mapGetters } from 'vuex'
import { mapFilters } from '@/filters/map-filters.js'
import Axios from 'axios'
import {
  soldOutSpec,
  lowInventorySpec,
  noInventorySpec,
  lowPricingInventorySpec,
  noPricingInventorySpec,
} from '@/rules/product-specs'
import { compareOnlyDateComponents, formatToISODate } from '@aspenware-library/helper-fns'

export default {
  props: {
    inventoryReady: Boolean,
  },
  data() {
    return {
      calendarDataHash: '000',
      lowInventoryThreshold: 0,
      lowInventoryText: 'Limited Availability',
      userDescriptionText: '',
      showLowInventoryBG: false,
      //this path below to the legend might change after review to make sure it fits in a spot that makes sense for all product/calendar types
      legendElement: document.getElementsByClassName('datepicker--legend'),
      lowInvUserDescTextElem: document.getElementById('low-inv-user-desc-text'),
      inlineDatepicker: document.getElementsByClassName('datepicker-inline'),
    }
  },
  created() {
    this.calendarDataHash = this.generateDataHash()
  },

  mounted() {
    this.checkForInlineDatepicker()
  },
  methods: {
    buildPriceHtml(priceMajor, priceMinor, separator) {
      var priceMajorFormatted = priceMajor
        .toLocaleString(this.locale.language, { style: 'currency', currency: this.locale.currency })
        .replace('.00', '')
      var priceMinorFormatted = priceMinor ? (priceMinor / 100).toFixed(2).replace('0.', '') : ''
      var showPriceMinor = !!priceMinor
      var priceMajorHtml = `<span class="price-major">${priceMajorFormatted}</span>`
      var priceMinorHtml = showPriceMinor ? `<span class="price-minor">${priceMinorFormatted}</span>` : ''

      return `<div class="price">${priceMajorHtml}<span class="price-separator">.</span>${priceMinorHtml}</div>`
    },

    generateDataHash() {
      // This random hash value is used to trigger an refresh of the calendar when data updates
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    },

    checkForInlineDatepicker() {
      if (this.inlineDatepicker.length > 0) {
        this.fetchCustomTemplateSettings()
      } else {
        return false
      }
    },

    fetchCustomTemplateSettings() {
      if (this.legendElement.length > 0) {
        this.removeLowInventoryNodes()
      } else {
        const root = document.querySelector(':root')
        const url = `/api/v1/settings/calendar?productId=${this.product.Id}&requiresTemplate=true`
        return Axios.get(url)
          .then((response) => {
            if (response.data.showLowInventory && response.data.usePosInventory) {
              this.showLowInventoryBG = true
              root.style.setProperty(
                '--low-inventory-date-background-color',
                response.data.lowInventoryDateBackgroundColor
              )
              this.lowInventoryThreshold = response.data.inventoryMessageThreshold
              this.lowInventoryText = response.data.lowStatusText
              this.addLowInventoryLegend()
              if (response.data.userDescription) {
                this.userDescriptionText = response.data.userDescription
                this.addUserDescriptionText()
              }
              return response.data
            } else {
              this.showLowInventoryBG = false
            }
          })
          .catch((error) => {
            console.log('Error fetching custom template settings', error)
          })
      }
    },
    addLowInventoryLegend() {
      $('.datepicker-inline').append(
        '<div class="datepicker--legend">' +
          '<ul>' +
          '<li><span class="datepicker--cell -selected-"></span>Date Selected</li>' +
          '<li><span class="-low-inventory-"></span>' +
          `${this.lowInventoryText}` +
          '</li>' +
          '</ul>' +
          '</div>'
      )
      $('.datepicker--cells').css('margin-top', '10px')
    },
    addUserDescriptionText() {
      if (this.userDescriptionText !== '') {
        const myElement = document.querySelector('.datepicker-inline')
        const span = `<span id="low-inv-user-desc-text"><p>${this.userDescriptionText}</p></span>`
        myElement.insertAdjacentHTML('beforebegin', span)
      }
    },
    removeLowInventoryNodes() {
      // TODO are both of these remove loops necessary?
      if (!this.showLowInventoryBG && this.legendElement.length) {
        $(this.legendElement).forEach((ele) => {
          ele.remove()
        })
      }
      const legendElements = $('.detail-summary-bar .datepicker--legend')
      if (legendElements.length) {
        legendElements.forEach((ele) => {
          ele.remove()
        })
      }
      if (this.lowInvUserDescTextElem) {
        document.getElementById(this.lowInvUserDescTextElem).remove()
      }
    },

    /**
     * @param {Date} date
     */
    renderSimpleDate(date, cellType) {
      let classes = ''
      let isDisabled = false
      let html = `<span>${date.getDate()}</span>`
      const dateKey = formatToISODate(date)
      let specClasses = []
      // If the date is before the earliest purchase date, disable it
      if (compareOnlyDateComponents(date, new Date(`${this.earliestPurchaseDate.format('YYYY-MM-DD')}T00:00:00`)) < 0) {
        isDisabled = true
      } else {
        if (
          noInventorySpec.isSatisfiedBy({
            product: this.product,
            date: dateKey,
          })
        ) {
          specClasses.push('-no-inventory-')
          isDisabled = true
          if (
            soldOutSpec.isSatisfiedBy({
              product: this.product,
              date: dateKey,
            })
          ) {
            specClasses.push('-sold-out-')
            html = `
                      <span class="line-through">${date.getDate()}</span>
                      <span class="tooltip">Sold Out</span>
                      `
          }
        }

        if (
          lowInventorySpec.isSatisfiedBy({
            product: this.product,
            date: dateKey,
            threshold: this.lowInventoryThreshold,
          })
        ) {
          specClasses.push('-low-inventory-')
        }

        if (
          noPricingInventorySpec.isSatisfiedBy({
            product: this.product,
            date: dateKey,
          })
        ) {
          specClasses.push('-no-pricing-inventory-')
          isDisabled = true
        }

        if (
          lowPricingInventorySpec.isSatisfiedBy({
            product: this.product,
            date: dateKey,
            threshold: this.lowInventoryThreshold,
          })
        ) {
          specClasses.push('-low-pricing-inventory-')
        }
      }

      classes += specClasses.join(' ')

      //add border to date cell if it has custom template
      if (this.showLowInventoryBG) {
        classes += ' -custom-template-border'
      }

      if (cellType === 'day') {
        return {
          disabled: isDisabled,
          classes: classes,
          html: html,
        }
      }
    },

    async updateMonthInventory({ selectedMonth, selectedYear }) {
      const _this = this

      if (!this.product.IsActivity) return

      // Dates for getting the pricing info
      const nextMonth = selectedMonth < 12 ? selectedMonth + 1 : 1
      const nextMonthYear = selectedMonth < 12 ? selectedYear : selectedYear + 1
      const firstDay = new Date(selectedYear, selectedMonth - 1, 1)
      const lastDay = new Date(nextMonthYear, nextMonth - 1, 0)

      const activityQuery = {
        code: this.product.Activity.Code,
        location: this.product.Activity.Location,
        productHeaderCode: this.product.ProductHeaderCode,
        startDate: `${firstDay.getFullYear()}-${firstDay.getMonth() + 1}-${firstDay.getDate()}`,
        endDate: `${lastDay.getFullYear()}-${lastDay.getMonth() + 1}-${lastDay.getDate()}`,
      }
      await _this.$store.dispatch('activities/getAvailability', activityQuery)

      _this.calendarDataHash = _this.generateDataHash()
    },

    async loadInventory() {
      await this.$store.dispatch('products/loadProductInventory')
    },

    ...mapFilters(['removeCurrencyFraction']),
  },
  computed: {
    productDateAttribute() {
      return !_.isEmpty(this.dateAttributes) ? this.dateAttributes[0] : null
    },

    epd() {
      return this.earliestPurchaseDate?.startOf('day')
    },

    ...mapGetters({
      dateAttributes: 'products/dateAttributes',
      earliestPurchaseDate: 'products/selectedProductEarliestPurchaseDate',
      inventoryUpdating: 'products/inventoryUpdating',
      purchasableInventory: 'products/selectedProductPurchasableInventory',
      locale: 'global/locale',
      product: 'products/selectedProduct',
    }),
  },
  watch: {
    purchasableInventory: function () {
      this.calendarDataHash = this.generateDataHash()
    },
    inventoryUpdating(newVal, oldVal) {
      // refresh when transitioning from "is loading" to "is not loading"
      if (!newVal && oldVal) {
        this.calendarDataHash = this.generateDataHash()
      }
    },
    inventoryReady(newVal, oldVal) {
      if (!newVal || newVal === oldVal) return

      setTimeout(() => {
        this.inlineDatepicker = document.getElementsByClassName('datepicker-inline')
        this.checkForInlineDatepicker()
      })
    },
    product: {
      immediate: true,
      handler() {
        this.loadInventory()
      },
    },
  },
  render() {
    return this.$scopedSlots.default({
      inventoryDataHash: this.calendarDataHash,
      inventoryDataUpdating: this.inventoryUpdating,
      productDateAttribute: this.productDateAttribute,
      renderFullDate: this.renderFullDate,
      renderSimpleDate: this.renderSimpleDate,
      updateMonthInventory: this.updateMonthInventory,
    })
  },
}
</script>

<style lang="scss">
:root {
  --low-inventory-date-background-color: '';
}

.-low-inventory- {
  background-color: var(--low-inventory-date-background-color);
  border-radius: 4px;
}

.-custom-template-border {
  border: 1px solid #bdc6d5;
  margin: 1px;
}

.datepicker--legend {
  margin-top: 15px;

  ul {
    list-style: none;
  }

  li {
    display: block;
    margin: 10px 0 5px 0;
    clear: both;
  }

  span {
    border: 1px solid #ccc;
    float: left;
    min-height: 25px;
    max-height: 25px;
    min-width: 20px;
    max-width: 20px;
    margin-right: 5px;
  }
}

#low-inv-user-desc-text p {
  line-height: 1.4rem;
  font-weight: bold;
  margin-bottom: 5px;
}

.datepicker-inline {
  margin-top: 5px;
}

.datepicker--cell-day.-other-month- {
  border: none !important;
  background: none !important;

  & .-hover- {
    pointer-events: none;
    background: none;
  }

  & .-focus- {
    pointer-events: none;
    background: none;
  }
}
</style>
